$('document').ready(function() {
    $('.info__item').on('click', function() {
        $(this).find('.question').toggleClass("clicked");
        $(this).find('.info').toggleClass("clicked");
    });
});